import React from "react";
import { NavLink } from "react-router-dom";

export default function CorporateTrainingSolutions() {
  return (
    <section className="container page-top pt-10" style={{ paddingTop: "6rem" }}>
      <div className="container">
        {/* Title Section */}
        <div className="row mb-4">
          <div className="col-12 text-center">
            <h1 className="display-5 fw-bold text-primary">Corporate Training Solutions</h1>
            <h5 className="text-muted">
              Customized Learning Paths to Upskill Your Workforce for the Future
            </h5>
            <hr className="w-25 mx-auto" />
          </div>
        </div>

        {/* Image and Introduction */}
        <div className="row align-items-center mb-5">
          <div className="col-md-6">
            <img
              src="https://img.freepik.com/free-vector/employee-training-concept-illustration_114360-15379.jpg"
              alt="Corporate Training"
              className="img-fluid rounded shadow"
            />
          </div>
          <div className="col-md-6">
            <h2 className="fw-semibold">Elevate Your Team's Capabilities</h2>
            <p>
              At <strong>Bytlas Intelligence</strong>, we specialize in delivering corporate training that drives results. From technical upskilling to soft skills, our programs are tailored to your organization's specific goals and delivered by certified trainers.
            </p>
            <ul className="list-group list-group-flush">
              <li className="list-group-item">✅ Customized Corporate Workshops</li>
              <li className="list-group-item">✅ Microsoft-Certified Power BI & Excel Training</li>
              <li className="list-group-item">✅ Cybersecurity Awareness Sessions</li>
              <li className="list-group-item">✅ Soft Skills, Leadership & Productivity Modules</li>
            </ul>
          </div>
        </div>

        {/* Benefits Section */}
        <div className="row my-5">
          <div className="col-md-6">
            <h3 className="text-secondary">Why Choose Us?</h3>
            <ul>
              <li>🎓 Experienced & Certified Trainers</li>
              <li>📊 Practical, Hands-on Learning</li>
              <li>🧑‍🏫 On-Site & Virtual Training Options</li>
              <li>📈 Measurable Learning Outcomes</li>
              <li>🔒 Domain-Specific Compliance Training</li>
            </ul>
          </div>

          <div className="col-md-6">
            <h3 className="text-secondary">Industries We Serve</h3>
            <p>
              From IT and finance to manufacturing and government, our corporate training covers a wide range of domains:
            </p>
            <ul>
              <li>💻 IT & Software Development</li>
              <li>🏢 Corporate & Enterprise Operations</li>
              <li>🏛️ Government & Public Sector</li>
              <li>🏥 Healthcare & Insurance</li>
              <li>📦 BPO & Customer Service</li>
            </ul>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-4">
          <NavLink to="/contact" className="btn btn-danger px-4 py-2 rounded-pill fw-bold">
            Request a Custom Training Proposal
          </NavLink>
        </div>
      </div>
    </section>
  );
}
